import { render, staticRenderFns } from "./CaseChronology.vue?vue&type=template&id=5862bf96&scoped=true"
import script from "./CaseChronology.vue?vue&type=script&lang=js"
export * from "./CaseChronology.vue?vue&type=script&lang=js"
import style0 from "./CaseChronology.vue?vue&type=style&index=0&id=5862bf96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5862bf96",
  null
  
)

export default component.exports